/* import __COLOCATED_TEMPLATE__ from './workflow.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';

interface Signature {
  Args: {
    onNext?: () => void;
  };
}

export default class WorkflowComponent extends Component<Signature> {
  @service declare finStandaloneService: FinStandaloneService;

  get freshdeskConfig() {
    return this.finStandaloneService.freshdeskConfig!;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Freshdesk::Deploy::Tickets::Workflow': typeof WorkflowComponent;
  }
}
